export default () => ({
  list: [],
  listForUser: [],
  application: null,
  appUser: null,
  loopIndex: null,
  listAllForUser: [],
  tags: [],
})
